import React from 'react'
import pretty from '@st-operations/uikit/lib/pretty.js'
import { IconButton } from '@st-operations/uikit/src/v2'
import { useModal } from '_hooks'
import { PermissionSetModal } from './PermissionSetModal.jsx'

export function PermissionSetItem({ id, application, name }) {
  const modal = useModal(false)

  return (
    <>
      {modal.isOpen && <PermissionSetModal id={id} onClose={modal.handleCloseModal} />}
      <tr className="px-4 py-2 border-b border-gray-200 last-child:border-gray">
        <td className="body-md pl-4 py-2">{pretty(application)}</td>
        <td className="body-md pl-4 py-2">{pretty(name)}</td>
        <td>
          <div className="flex gap-1 items-end">
            <IconButton
              iconProps={{
                icon: 'edit',
                width: 24,
                height: 24,
                color: 'currentColor',
              }}
              onClick={modal.handleOpenModal}
            />
          </div>
        </td>
      </tr>
    </>
  )
}
